import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "bs-account",
  ref: "containerReference"
}
const _hoisted_2 = { class: "trigger__container" }
const _hoisted_3 = { class: "trigger__user" }
const _hoisted_4 = { class: "user__name" }
const _hoisted_5 = {
  key: 0,
  class: "user__role"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m6 9 6 6 6-6" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_avatar = _resolveComponent("bs-avatar")!
  const _component_account_tooltip = _resolveComponent("account-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bs-account__trigger",
      ref: "reference",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_bs_avatar),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.username), 1),
          (Boolean(_ctx.role))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.role), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_6
    ], 512),
    _createVNode(_Transition, { name: "m-tooltip" }, {
      default: _withCtx(() => [
        (_ctx.isVisible)
          ? (_openBlock(), _createBlock(_component_account_tooltip, {
              key: 0,
              class: "bs-m-tooltip",
              ref: "tooltip",
              style: _normalizeStyle({ position: _ctx.strategy, width: _ctx.containerWidth, left: `${_ctx.x}px`, top: `${_ctx.y}px` }),
              onLogout: _ctx.onLogout
            }, null, 8, ["style", "onLogout"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}